var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 806,
    height: 589,
    viewBox: "0 0 806 589",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.5,
    cy: 294.5,
    rx: 303.5,
    ry: 294.5,
    fill: "#4A5862"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M693 294C693 453.61 557.342 583 390 583C222.658 583 87 453.61 87 294C87 134.39 222.658 5 390 5C557.342 5 693 134.39 693 294Z",
    fill: "#3F4A53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M397.348 273.705C478.934 273.705 552.759 277.038 606.155 282.419C632.868 285.111 654.388 288.308 669.187 291.834C676.607 293.602 682.202 295.422 685.889 297.238C687.739 298.149 688.973 298.994 689.713 299.728C690.448 300.457 690.5 300.873 690.5 301C690.5 301.127 690.448 301.543 689.713 302.272C688.973 303.006 687.739 303.851 685.889 304.762C682.202 306.578 676.607 308.398 669.187 310.166C654.388 313.692 632.868 316.889 606.155 319.581C552.759 324.962 478.934 328.295 397.348 328.295C315.762 328.295 241.937 324.962 188.541 319.581C161.828 316.889 140.308 313.692 125.509 310.166C118.089 308.398 112.494 306.578 108.807 304.762C106.957 303.851 105.723 303.006 104.983 302.272C104.248 301.543 104.196 301.127 104.196 301C104.196 300.873 104.248 300.457 104.983 299.728C105.723 298.994 106.957 298.149 108.807 297.238C112.494 295.422 118.089 293.602 125.509 291.834C140.308 288.308 161.828 285.111 188.541 282.419C241.937 277.038 315.762 273.705 397.348 273.705Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M397.348 224.86C478.838 224.86 552.524 233.648 605.763 247.809C632.401 254.894 653.777 263.288 668.435 272.506C683.22 281.804 690.5 291.496 690.5 301C690.5 310.504 683.22 320.196 668.435 329.494C653.777 338.712 632.401 347.106 605.763 354.191C552.524 368.352 478.838 377.14 397.348 377.14C315.858 377.14 242.172 368.352 188.933 354.191C162.295 347.106 140.919 338.712 126.26 329.494C111.476 320.196 104.196 310.504 104.196 301C104.196 291.496 111.476 281.804 126.26 272.506C140.919 263.288 162.295 254.894 188.933 247.809C242.172 233.648 315.858 224.86 397.348 224.86Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M397.348 169.177C478.717 169.177 552.262 184.166 605.372 208.295C658.707 232.527 690.5 265.492 690.5 301C690.5 336.509 658.707 369.473 605.372 393.705C552.262 417.834 478.717 432.823 397.348 432.823C315.979 432.823 242.434 417.834 189.324 393.705C135.989 369.473 104.196 336.509 104.196 301C104.196 265.492 135.989 232.527 189.324 208.295C242.434 184.166 315.979 169.177 397.348 169.177Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.233 106.655C473.451 106.655 546.867 128.578 599.905 163.891C652.961 199.215 685.385 247.74 685.385 301C685.385 354.26 652.961 402.785 599.905 438.109C546.867 473.422 473.451 495.345 392.233 495.345C311.015 495.345 237.599 473.422 184.561 438.109C131.505 402.785 99.0806 354.26 99.0806 301C99.0806 247.74 131.505 199.215 184.561 163.891C237.599 128.578 311.015 106.655 392.233 106.655Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388.652 55.368C550.984 55.368 681.804 165.734 681.804 301C681.804 436.266 550.984 546.632 388.652 546.632C226.32 546.632 95.5 436.266 95.5 301C95.5 165.734 226.32 55.368 388.652 55.368Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M389.5 7.5C551.372 7.5 682.5 135.823 682.5 294C682.5 452.177 551.372 580.5 389.5 580.5C227.628 580.5 96.5 452.177 96.5 294C96.5 135.823 227.628 7.5 389.5 7.5Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M425.5 294C425.5 373.746 422.088 445.904 416.581 498.091C413.825 524.201 410.553 545.227 406.946 559.684C405.138 566.932 403.278 572.39 401.425 575.983C400.496 577.783 399.635 578.985 398.885 579.706C398.145 580.419 397.693 580.5 397.5 580.5C397.307 580.5 396.855 580.419 396.115 579.706C395.365 578.985 394.504 577.783 393.575 575.983C391.722 572.39 389.862 566.932 388.054 559.684C384.447 545.227 381.175 524.201 378.419 498.091C372.912 445.904 369.5 373.746 369.5 294C369.5 214.254 372.912 142.096 378.419 89.9085C381.175 63.7993 384.447 42.7725 388.054 28.3163C389.862 21.0681 391.722 15.6104 393.575 12.0174C394.504 10.2167 395.365 9.01487 396.115 8.29349C396.855 7.58105 397.307 7.5 397.5 7.5C397.693 7.5 398.145 7.58105 398.885 8.29349C399.635 9.01487 400.496 10.2167 401.425 12.0174C403.278 15.6104 405.138 21.0681 406.946 28.3163C410.553 42.7725 413.825 63.7993 416.581 89.9085C422.088 142.096 425.5 214.254 425.5 294Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M475.5 294C475.5 373.645 466.505 445.659 452.014 497.683C444.763 523.713 436.175 544.596 426.746 558.914C417.251 573.332 407.316 580.5 397.5 580.5C387.684 580.5 377.749 573.332 368.254 558.914C358.825 544.596 350.237 523.713 342.986 497.683C328.495 445.659 319.5 373.645 319.5 294C319.5 214.355 328.495 142.341 342.986 90.317C350.237 64.2873 358.825 43.4039 368.254 29.0861C377.749 14.6679 387.684 7.5 397.5 7.5C407.316 7.5 417.251 14.6679 426.746 29.0861C436.175 43.4039 444.763 64.2873 452.014 90.317C466.505 142.341 475.5 214.355 475.5 294Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M532.5 294C532.5 373.518 517.16 445.385 492.47 497.28C467.69 549.361 433.947 580.5 397.5 580.5C361.053 580.5 327.31 549.361 302.53 497.28C277.84 445.385 262.5 373.518 262.5 294C262.5 214.482 277.84 142.615 302.53 90.7202C327.31 38.6385 361.053 7.5 397.5 7.5C433.947 7.5 467.69 38.6385 492.47 90.7202C517.16 142.615 532.5 214.482 532.5 294Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M591.5 294C591.5 373.357 569.069 445.094 532.931 496.924C496.788 548.763 447.098 580.5 392.5 580.5C337.901 580.5 288.212 548.763 252.069 496.924C215.931 445.094 193.5 373.357 193.5 294C193.5 214.643 215.931 142.906 252.069 91.076C288.212 39.2374 337.901 7.5 392.5 7.5C447.098 7.5 496.788 39.2374 532.931 91.076C569.069 142.906 591.5 214.643 591.5 294Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M640.5 294C640.5 452.543 527.606 580.5 389 580.5C250.394 580.5 137.5 452.543 137.5 294C137.5 135.457 250.394 7.5 389 7.5C527.606 7.5 640.5 135.457 640.5 294Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M690.5 294C690.5 452.119 556.074 580.5 390 580.5C223.926 580.5 89.5 452.119 89.5 294C89.5 135.881 223.926 7.5 390 7.5C556.074 7.5 690.5 135.881 690.5 294Z",
    stroke: "#4C545E",
    strokeWidth: 5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M275.23 22.8513C185.213 -76.8595 499 701.495 499 571.26",
    stroke: "#C7C3C3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M680 184C784.999 47.5 15.3038 581.787 172.5 495.5",
    stroke: "#C7C3C3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M597 70.0001C641.5 -44.4999 85.4997 552.5 200.5 521.5",
    stroke: "#C7C3C3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_28_383)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 453,
    r: 10,
    fill: "#18B4EA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_28_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.5 543.85C471.5 549.373 467.023 553.85 461.5 553.85C455.977 553.85 451.5 549.373 451.5 543.85C451.5 538.327 455.977 533.85 461.5 533.85C467.023 533.85 471.5 538.327 471.5 543.85Z",
    fill: "#18B4EA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_28_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M565 83C565 88.5228 560.523 93 555 93C549.477 93 545 88.5228 545 83C545 77.4772 549.477 73 555 73C560.523 73 565 77.4772 565 83Z",
    fill: "#18B4EA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_28_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548 238C548 243.523 543.523 248 538 248C532.477 248 528 243.523 528 238C528 232.477 532.477 228 538 228C543.523 228 548 232.477 548 238Z",
    fill: "#18B4EA"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_28_383)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 101,
    r: 10,
    fill: "#18B4EA"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_28_383)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 178.297,
    cy: 218.477,
    r: 85.4773,
    fill: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.4771,
    cy: 277.243,
    r: 58.7656,
    fill: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.855,
    cy: 293.27,
    r: 42.7386,
    fill: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.412,
    cy: 278.579,
    r: 52.0877,
    fill: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.345,
    cy: 266.558,
    r: 74.7926,
    fill: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.138,
    cy: 293.27,
    r: 50.7521,
    fill: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 517.535,
    cy: 341.351,
    r: 37.3963,
    fill: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.3963,
    cy: 341.351,
    r: 37.3963,
    fill: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.0542,
    y: 287.928,
    width: 488.823,
    height: 90.8196,
    fill: "#FCFEFF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_28_383)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 674.958,
    cy: 319.763,
    rx: 126.958,
    ry: 104.763,
    fill: "#F3FAFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 666.937,
    cy: 319.685,
    rx: 126.958,
    ry: 104.763,
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 528.32,
    cy: 346.41,
    rx: 63.4788,
    ry: 52.3815,
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 442.818,
    cy: 359.238,
    rx: 63.4788,
    ry: 52.3815,
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.976,
    cy: 370.997,
    rx: 25.9097,
    ry: 21.3802,
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.657,
    cy: 405.206,
    rx: 33.6826,
    ry: 27.7943,
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 765.394,
    cy: 405.206,
    rx: 33.6826,
    ry: 27.7943,
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 382,
    width: 423,
    height: 51,
    fill: "#F1F9FF"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M748.849 396.096C748.849 396.518 748.408 399.053 747.526 399.053C746.645 399.475 745.322 399.898 744.882 399.898C744.441 399.898 744 399.898 744 400.32C744 400.658 744.588 401.024 744.882 401.165C745.469 401.306 746.821 401.588 747.526 401.588C748.232 401.588 748.408 403.559 748.408 404.545C748.408 404.686 748.496 404.967 748.849 404.967C749.202 404.967 749.584 404.686 749.731 404.545C749.731 403.841 749.907 402.264 750.612 401.588C751.494 400.743 754.139 401.165 754.139 400.743C754.139 400.405 753.551 400.039 753.257 399.898C752.669 399.757 751.317 399.391 750.612 399.053C749.731 398.63 749.731 394.828 749.29 394.828C748.849 394.828 748.849 395.673 748.849 396.096Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.991 389.555C104.991 389.977 104.55 392.512 103.669 392.512C102.787 392.934 101.465 393.357 101.024 393.357C100.583 393.357 100.142 393.357 100.142 393.779C100.142 394.117 100.73 394.483 101.024 394.624C101.611 394.765 102.963 395.046 103.669 395.046C104.374 395.046 104.55 397.018 104.55 398.004C104.55 398.144 104.638 398.426 104.991 398.426C105.344 398.426 105.726 398.144 105.873 398.004C105.873 397.3 106.049 395.722 106.754 395.046C107.636 394.202 110.281 394.624 110.281 394.202C110.281 393.864 109.693 393.498 109.399 393.357C108.811 393.216 107.46 392.85 106.754 392.512C105.873 392.089 105.873 388.287 105.432 388.287C104.991 388.287 104.991 389.132 104.991 389.555Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.925 343.931C148.925 344.353 148.485 346.888 147.603 346.888C146.721 347.31 145.399 347.733 144.958 347.733C144.517 347.733 144.076 347.733 144.076 348.155C144.076 348.493 144.664 348.859 144.958 349C145.546 349.141 146.898 349.423 147.603 349.423C148.308 349.423 148.485 351.394 148.485 352.38C148.485 352.52 148.573 352.802 148.925 352.802C149.278 352.802 149.66 352.52 149.807 352.38C149.807 351.676 149.983 350.098 150.689 349.423C151.57 348.578 154.215 349 154.215 348.578C154.215 348.24 153.627 347.874 153.333 347.733C152.746 347.592 151.394 347.226 150.689 346.888C149.807 346.465 149.807 342.663 149.366 342.663C148.925 342.663 148.925 343.508 148.925 343.931Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M776.849 346.267C776.849 346.69 776.408 349.224 775.526 349.224C774.645 349.647 773.322 350.069 772.882 350.069C772.441 350.069 772 350.069 772 350.492C772 350.83 772.588 351.196 772.882 351.337C773.469 351.477 774.821 351.759 775.526 351.759C776.232 351.759 776.408 353.731 776.408 354.716C776.408 354.857 776.496 355.139 776.849 355.139C777.202 355.139 777.584 354.857 777.731 354.716C777.731 354.012 777.907 352.435 778.612 351.759C779.494 350.914 782.139 351.337 782.139 350.914C782.139 350.576 781.551 350.21 781.257 350.069C780.669 349.929 779.317 349.562 778.612 349.224C777.731 348.802 777.731 345 777.29 345C776.849 345 776.849 345.845 776.849 346.267Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M200.574 221.634C200.574 221.845 200.354 223.112 199.913 223.112C199.472 223.323 198.811 223.535 198.591 223.535C198.37 223.535 198.15 223.535 198.15 223.746C198.15 223.915 198.444 224.098 198.591 224.168C198.885 224.239 199.561 224.38 199.913 224.38C200.266 224.38 200.354 225.365 200.354 225.858C200.354 225.929 200.398 226.069 200.574 226.069C200.751 226.069 200.942 225.929 201.015 225.858C201.015 225.506 201.103 224.718 201.456 224.38C201.897 223.957 203.219 224.168 203.219 223.957C203.219 223.788 202.925 223.605 202.778 223.535C202.485 223.464 201.809 223.281 201.456 223.112C201.015 222.901 201.015 221 200.795 221C200.574 221 200.574 221.422 200.574 221.634Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M802.188 383.634C802.188 383.845 801.968 385.112 801.527 385.112C801.086 385.323 800.425 385.535 800.204 385.535C799.984 385.535 799.764 385.535 799.764 385.746C799.764 385.915 800.058 386.098 800.204 386.168C800.498 386.239 801.174 386.38 801.527 386.38C801.88 386.38 801.968 387.365 801.968 387.858C801.968 387.929 802.012 388.069 802.188 388.069C802.364 388.069 802.555 387.929 802.629 387.858C802.629 387.506 802.717 386.718 803.07 386.38C803.511 385.957 804.833 386.168 804.833 385.957C804.833 385.788 804.539 385.605 804.392 385.535C804.098 385.464 803.422 385.281 803.07 385.112C802.629 384.901 802.629 383 802.409 383C802.188 383 802.188 383.422 802.188 383.634Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4245 368.645C43.4245 368.856 43.2041 370.124 42.7632 370.124C42.3224 370.335 41.6612 370.546 41.4408 370.546C41.2204 370.546 41 370.546 41 370.757C41 370.926 41.2939 371.109 41.4408 371.18C41.7347 371.25 42.4106 371.391 42.7632 371.391C43.1159 371.391 43.2041 372.377 43.2041 372.87C43.2041 372.94 43.2481 373.081 43.4245 373.081C43.6008 373.081 43.7918 372.94 43.8653 372.87C43.8653 372.518 43.9534 371.729 44.3061 371.391C44.7469 370.969 46.0693 371.18 46.0693 370.969C46.0693 370.8 45.7755 370.617 45.6285 370.546C45.3347 370.476 44.6587 370.293 44.3061 370.124C43.8653 369.912 43.8653 368.011 43.6449 368.011C43.4245 368.011 43.4245 368.434 43.4245 368.645Z",
    fill: "#0053BF",
    stroke: "#0053BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_28_383",
    x: 199,
    y: 443,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_28_383",
    x: 447.5,
    y: 533.85,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_28_383",
    x: 541,
    y: 73,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_28_383",
    x: 524,
    y: 228,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_28_383",
    x: 262,
    y: 91,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_28_383",
    x: 0,
    y: 133,
    width: 556.932,
    height: 249.747,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_28_383",
    x: 309.974,
    y: 214.922,
    width: 493.941,
    height: 222.078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_383",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudGraphic);
export default __webpack_public_path__ + "static/media/Cloud_Graphic.b59f6436bd77687ef9edb97a3069e972.svg";
export { ForwardRef as ReactComponent };